import { render, staticRenderFns } from "./TypeFormdata.vue?vue&type=template&id=666ca544&"
import script from "./TypeFormdata.vue?vue&type=script&lang=js&"
export * from "./TypeFormdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports